import { AccountSidebarVisibilityUseCase } from '~use-cases/AccountSidebarVisibilityUseCase';

export class ServiceBusController {
    public showOverlay = () => {
        new AccountSidebarVisibilityUseCase(true).execute();
    };

    public hideOverlay = () => {
        new AccountSidebarVisibilityUseCase(false).execute();
    };
}
